export default "__VITE_ASSET__Dyzbdl5B__"